import React from "react";
import { Lock, Check } from "lucide-react";
import { toast } from "sonner";
import api, { apiErr } from "@/lib/api";
import { setCosmetics } from "@/lib/cosmetics";
import { FrameAvatar } from "./FrameAvatar";

export const FramePicker = ({ state, name }) => {
  const equip = async (key) => {
    try { const r = await api.post("/cosmetics/frame", { key }); setCosmetics(r.data); toast.success(key ? "Frame equipped." : "Frame removed."); }
    catch (e) { toast.error(apiErr(e)); }
  };
  const eq = state.equipped_frame;
  return (
    <section className="tc-card p-5 space-y-4" data-testid="frame-picker">
      <div className="flex items-center gap-4">
        <FrameAvatar name={name} frame={eq} size={64} testid="profile-frame-avatar" />
        <div className="min-w-0">
          <h2 className="font-heading font-bold">Profile frame</h2>
          <p className="text-xs text-tc-muted">Earned by learning milestones. A frame changes how your name looks and nothing else.</p>
        </div>
      </div>
      <div className="grid gap-2 sm:grid-cols-2">
        <button data-testid="frame-option-none" onClick={() => equip(null)}
          className={`rounded-lg border px-3 py-2 text-left text-sm flex items-center justify-between gap-2 transition-colors ${!eq ? "border-tc-coach/60 bg-tc-coach/10" : "border-white/10 hover:border-white/30"}`}>
          <span>No frame</span>{!eq && <Check className="w-4 h-4 text-tc-coach" />}
        </button>
        {state.frames.map((f) => (
          <button key={f.key} data-testid={`frame-option-${f.key}`} disabled={!f.earned} onClick={() => equip(f.key)}
            className={`rounded-lg border px-3 py-2 text-left text-sm flex items-center gap-3 transition-colors disabled:cursor-not-allowed ${eq === f.key ? "border-tc-coach/60 bg-tc-coach/10" : "border-white/10 hover:border-white/30 disabled:hover:border-white/10"}`}>
            <span className={f.earned ? "" : "opacity-60"}><FrameAvatar name={name} frame={f.key} size={32} /></span>
            <span className="min-w-0 flex-1">
              <span className="block font-medium">{f.name}</span>
              <span className="block text-[11px] text-tc-muted">{f.how}</span>
            </span>
            {eq === f.key ? <Check className="w-4 h-4 text-tc-coach shrink-0" />
              : !f.earned ? <Lock className="w-4 h-4 text-tc-muted shrink-0" data-testid={`frame-locked-${f.key}`} /> : null}
          </button>
        ))}
      </div>
    </section>
  );
};
